import React from 'react';
import {withRouter} from 'react-router-dom';
import { Declaration } from 'components/importExport/declaration/Declaration';
import ScrollToTop from "../../../utils/ScrollToTop";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import { useDispatch } from "react-redux";
import {saveImportExportApplication} from "../../../redux/actions";

const IndividualDeclaration = props => {

  ScrollToTop();
  RedirectIfCaptchaNotSelected(props);

  const dispatch = useDispatch();  

  const continueButtonHandler = () => {
    dispatch(
      saveImportExportApplication("", () => {
        props.history.push('./individual-fee-breakdown')  
      })
    );           
  }   

  const saveApplication = () => {
    dispatch(
      saveImportExportApplication("", () => {
          props.history.push(`./dashboard`);
      })
    );           
  }
  
  return (
    <Declaration props={props} continueButtonHandler={continueButtonHandler} saveApplication= {saveApplication}/>
  )
};
  
  export default withRouter(props => <IndividualDeclaration {...props}/>);
  
